import React from "react";
import cx from "classnames";
import ReactSlick from "react-slick";
import PropTypes from "prop-types";
import { getSrc } from "gatsby-plugin-image";

import Link from "../Link";

import "./style.scss";

const Slider = ({ classNames, items, settings, ...rest }) => {
  const setDefaultSetting = (
    slidesToShow,
    slidesToScroll,
    autoplay,
    arrows,
    infinite
  ) => ({
    slidesToShow,
    slidesToScroll,
    autoplay,
    arrows,
    infinite,
  });

  const _settings = {
    dots: false,
    speed: 1000,
    ...setDefaultSetting(1, 1, false, false, false),
    ...settings.default,
    responsive: [
      {
        breakpoint: 1000,
        settings:
          settings.mediumScreen && Object.keys(settings.mediumScreen).length
            ? settings.mediumScreen
            : setDefaultSetting(1, 1, true, false, true),
      },

      {
        breakpoint: 600,
        settings:
          settings.smallScreen && Object.keys(settings.smallScreen).length
            ? settings.smallScreen
            : setDefaultSetting(1, 1, true, false, true),
      },
    ],
  };

  return (
    <div className={cx("slider", classNames)} {...rest}>
      <ReactSlick {..._settings}>
        {items.map((item, i) => (
          <Link to={item.linkTo} key={`slider-${item.title}-${i}`}>
            <div className="article-card d-flex justify-content-center">
              <img
                className="card-img-top"
                src={getSrc(item.image)}
                alt={""}
                style={{
                  maxWidth: "450px",
                }}
              />
              {item.title && (
                <div className="card-body">
                  <h5 dangerouslySetInnerHTML={{ __html: item.title }} />
                </div>
              )}
            </div>
          </Link>
        ))}
      </ReactSlick>
    </div>
  );
};

const SettingPropTypes = {
  slidesToShow: PropTypes.number,
  slidesToScroll: PropTypes.number,
  autoplay: PropTypes.bool,
  arrows: PropTypes.bool,
  infinite: PropTypes.bool,
};

Slider.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      linkTo: PropTypes.string.isRequired,
      image: PropTypes.any.isRequired,
      title: PropTypes.string,
    })
  ).isRequired,

  settings: PropTypes.shape({
    default: PropTypes.shape(SettingPropTypes),
    mediumScreen: PropTypes.shape(SettingPropTypes),
    smallScreen: PropTypes.shape(SettingPropTypes),
  }),
};

export default Slider;
